import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {GLOBAL_MEASUREMENT_TYPES_CATEGORIES_QUERY_KEY} from '../../api/queries/getGlobalMeasurementTypesCategories'
import {GlobalMeasurementTypesCategory} from '../../types/GlobalMeasurementTypesCategory'

import {useSettingsQuery} from '@settings/modules/common/providers'

export function useGlobalMeasurementTypesCategoriesQuery(): UseQueryResult<
  GlobalMeasurementTypesCategory[],
  unknown
> {
  const {t} = useTranslation()

  return useSettingsQuery(GLOBAL_MEASUREMENT_TYPES_CATEGORIES_QUERY_KEY, [], {
    select: (globalMeasurementTypesCategories) =>
      globalMeasurementTypesCategories.sort((current, next) => (current.name > next.name ? 1 : -1)),
    meta: {
      errorMessage: t('measurementsSettings.queryError', {
        entity: 'Global Measurement Types Categories'
      })
    }
  })
}
